<template lang="pug">
v-badge(
  :value="false"
  dot
  overlap
  :offset-x="18"
  :offset-y="16"
  color="ui-warning"
)
  v-btn.ui-background(
    color="ui-neutral"
    icon
    exact
    exact-active-class="redesignPrimaryDarken--text"
    :to="{ name: 'notification' }"
  )
    v-icon(:size="20") {{ hasNotifications ? '$ui-notification-active' : '$ui-notification' }}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  data() {
    return {};
  },
  props: {},
  computed: {
    ...mapGetters({
      notificationsCount: 'notification/total',
    }),
    hasNotifications() {
      return this.notificationsCount > 0;
    },
  },
};
</script>
